import { render } from "./change_password.vue?vue&type=template&id=7a951aa6&scoped=true"
import script from "./change_password.vue?vue&type=script&lang=js"
export * from "./change_password.vue?vue&type=script&lang=js"

import "./change_password.vue?vue&type=style&index=0&id=7a951aa6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holo\\work\\git-all-source,\\stress_check_Rebuild\\source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a951aa6"]])

export default __exports__